import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import '@babel/polyfill'

Vue.config.productionTip = false

// Custom components
import Navigation from './components/Navigation.vue'
import Sidebar from './components/Sidebar.vue'
import Product from './components/Product.vue'
import CartItem from './components/CartItem.vue'
import Loader from './components/Loader.vue'
import FormErrors from './components/FormErrors.vue'
import CategoryPreview from './components/CategoryPreview.vue'
import CookieNotice from './components/CookieNotice.vue'

Vue.component('navigation', Navigation)
Vue.component('product', Product)
Vue.component('sidebar', Sidebar)
Vue.component('loader', Loader)
Vue.component('category-preview', CategoryPreview)
Vue.component('cart-item', CartItem)
Vue.component('form-errors', FormErrors)
Vue.component('cookie-notice', CookieNotice)

// Http
import http from './http'
Vue.prototype.$http = http

// JWT token
const token = localStorage.getItem('token')
if (token) {
	Vue.prototype.$http.defaults.headers.common['Authorization'] =
		'Bearer ' + token
}

// Noty
window.Noty = require('noty')

new Vue({
	router,
	store,
	render: (h) => h(App),
}).$mount('#app')
